<template>
  <div>
    <exo-table :root="_self">
      <exo-form :root="_self">
        <template v-slot:titleTooltip>
          <exo-help-dialog
            :color="'black--text'"
            :margin="'m-0'"
            title="Space object Definition"
            ><h3>NORAD ID</h3>
            <p>
              The space object is currently identified by its NORAD ID (also
              known as the Satellite Catalog Number or SATCAT). Its NORAD number
              is then used to retrieve its corresponding measures.
            </p>
            <h3>Additional Fields</h3>
            <p>
              The other fields that are required to be field are related to its
              propulsion system via the thrust and the ISP.
            </p>
            <p>
              The total mass correspond to the estimated dry mass of the space
              object and the propellant.
            </p>
            <p>
              The spherical cross section of the space object corresponds to the
              equivalent spherical surface used to calculate the drag
              contributions.
            </p></exo-help-dialog
          >
        </template>
        <exo-input-name :root="_self" />
        <exo-input-double :root="_self" name="noradID" />
        <v-divider />

        <div>
          <exo-card-form label="Space Object Propulsion System">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <exo-input-double
                    :root="_self"
                    name="thrust"
                    tooltip="Thrust of the propulsion system"
                  />

                  <exo-input-double
                    :root="_self"
                    name="isp"
                    tooltip="Specific impulse of the space object"
                  />
                </v-row>
              </v-col>
            </v-row>
          </exo-card-form>
          <exo-card-form label="Space Object Mass">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <exo-input-double
                    :root="_self"
                    name="totalMass"
                    tooltip="Total mass of the space object including propellant"
                  />
                  <exo-input-double
                    :root="_self"
                    name="propellantMass"
                    tootltip="Mass of propellant of the space object"
                  />
                </v-row>
              </v-col>
            </v-row>
          </exo-card-form>
          <exo-card-form label="Space Object Geometry">
            <v-row>
              <exo-input-double
                :root="_self"
                name="sphericalCrossSection"
                tootltip="Spherical Cross Section of the space object"
              />
            </v-row>
          </exo-card-form>
        </div>
      </exo-form>
    </exo-table>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'

export default {
  name: 'spaceobject',

  components: {},

  mixins: [formMixin, numericalMixin],

  mounted() {
    this.refreshReferences()
  },

  computed: {
    disabledPropulsionConfiguration() {
      return 'disabledOnManeuverAnalysis'
    }
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'noradID', text: 'NORAD Number', sortable: true },
        {
          value: 'sphericalCrossSection',
          text:
            'Spherical cross section' +
            this.getDefaultUnitLabel('sphericalCrossSection'),
          sortable: true
        },
        {
          value: 'totalMass',
          text: 'Total Mass' + this.getDefaultUnitLabel('totalMass'),
          sortable: true
        },
        {
          value: 'propellantMass',
          text: 'Propellant mass' + this.getDefaultUnitLabel('propellantMass'),
          sortable: true
        },
        {
          value: 'thrust',
          text: 'Space object thrust' + this.getDefaultUnitLabel('thrust'),
          sortable: true
        },
        {
          value: 'isp',
          text: 'Specific impulse' + this.getDefaultUnitLabel('isp'),
          sortable: true
        },

        { value: 'actions', text: 'Actions', sortable: false }
      ],

      modalRef: { content: [] },
      showModal: false,

      enumPropertiesList: this.getEnumProperties(),
      spacecraftsNotParametrics: [],

      inputs: {
        noradID: this.getDefaultValue('noradID'),
        sphericalCrossSection: this.getDefaultValue('sphericalCrossSection'),
        totalMass: this.getDefaultValue('totalMass'),
        propellantMass: this.getDefaultValue('propellantMass'),
        thrust: this.getDefaultValue('thrust'),
        isp: this.getDefaultValue('isp'),
        spacecraft: this.getDefaultValue('spacecraft')
      },
      knownSpacecraftFields: [
        'sphericalCrossSection',
        'totalMass',
        'propellantMass',
        'thrust',
        'isp'
      ]
    }
  },

  methods: {
    getRequiredPropertiesList(instance) {
      if (this.getCurrentFormDescription().required == null) {
        return []
      }
      let requiredList = this.getCurrentFormDescription().required.slice()
      for (const field of this.knownSpacecraftFields) {
        requiredList.push(field)
      }

      return requiredList
    },

    refreshReferences() {
      this.refreshSpacecrafts()
    },

    refreshSpacecrafts() {
      let self = this
      this.$http
        .get(this.getAPI('spacecraftdefinitions'))
        .then((response) => {
          self.spacecraftsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of spacecrafts. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getCurrentFormType() {
      return 'SpaceObjectDefinition'
    },

    getRefList(param) {
      return []
    }
  }
}
</script>
